/**
 * 盘点记录
 */
import React from "react";

import { Row, Col, Select, DatePicker, Button, Input } from "antd";
import PageLayout from "../../ui/PageLayout";
import StockCheckView from "./StockCheckView";
import StockCheckConfig from "../stockCheckConfig/StockCheckConfig";
import http from "../../../axios/http";
import moment from "moment";
import { global_data } from '../../ui/auth'
const { RangePicker } = DatePicker;

class StockCheckList extends React.Component {
  columns = [
    {
      title: "盘点日期",
      dataIndex: "date",
    },
    {
      title: "商户",
      dataIndex: "memberName",
    },
    {
      title: "车架号",
      dataIndex: "vin",
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
    },
    {
      title: "盘点人",
      dataIndex: "checkUName",
    },
    {
      title: "状态",
      dataIndex: "stateStr",
    },
    {
      title: "详情",
      dataIndex: "id",
      width: "10%",
      render: (record) => {
        return <div>{this.showOperation(record)}</div>;
      },
    },
  ];

  state = {
    loadData: "",
    viewData: {},
    visible: false,
    configVisible: false,
    checkPeriodDay: null,
    config: {
      fullCheck: 0,
      RandomPeriod: " ",
    },
    queryData: { type: 0 },
  };

  componentWillMount() {
    this.loadConfig();
  }

  loadConfig() {
    http.post({
      url: "/vehicleStockCheck/configs",
      success: (res) => {
        this.setState({ configData: res });
        var config = this.state.config;
        res.forEach((element) => {
          config[element.ckey] = Number(element.cvalue);
        });
        this.setState({ config });
      },
    });
    http.post({
      url: "/vehicleStockCheck/getCheckPeriodDay",
      success: (res) => {
        this.setState({ checkPeriodDay: res });
      },
    });
  }

  showOperation(record) {
    var rslt = [];
    if (record.state > 0) {
      rslt = (
        <Button
          type="link"
          onClick={this.viewDetail.bind(this, record)}
          style={{
            height: "initial",
          }}
        >
          查看详情
        </Button>
      );
    }
    return rslt;
  }

  hiddenModal = () => {
    this.setState({ visible: false });
  };

  viewDetail = (info, e) => {
    this.setState({ viewData: info, visible: true });
  };

  hideConfig = () => {
    this.setState({ configVisible: false });
    let queryData = this.state.queryData;
    this.state.loadData(queryData);
    this.loadConfig();
  };

  openConfig = () => {
    this.setState({ configVisible: true });
  };

  periodChange = (val, valstr) => {
    console.log("periodChange", valstr);
    let queryData = this.state.queryData;

    queryData["start"] = valstr[0];
    queryData["end"] = valstr[1];
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  keywordChange = (val) => {
    console.log("keywordChange", val);
    let queryData = this.state.queryData;
    queryData["keyword"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  typeChange = (val) => {
    let queryData = this.state.queryData;
    queryData["type"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={3}>
                <Select
                  style={{ width: "100%" }}
                  value={this.state.queryData.type}
                  onChange={this.typeChange}
                >
                  <Select.Option value={0}>全部</Select.Option>
                  <Select.Option value={1}>异常</Select.Option>
                  <Select.Option value={2}>正常</Select.Option>
                  <Select.Option value={5}>待盘</Select.Option>
                </Select>
              </Col>
              <Col span={6} style={{ "padding-left": "10px" }}>
                <RangePicker
                  onChange={this.periodChange}
                  ranges={{
                    今天: [moment(), null],
                    昨天: [
                      moment().subtract(1, "days"),
                      moment().subtract(1, "days"),
                    ],
                    本周: [moment().startOf("week"), moment().endOf("week")],
                  }}
                  format="YYYY-MM-DD"
                />
              </Col>
              <Col span={6} style={{ "padding-left": "10px" }}>
                <Input.Search
                  onSearch={this.keywordChange}
                  placeholder="输入车辆关键字搜索"
                />
              </Col>
              <Col span={9} style={{ textAlign: "right" }}>
                {global_data.authCode.includes("STOCK_CHECK_LIST_CONFIG")?
                <Button onClick={this.openConfig.bind(this)} type="primary">
                  盘点配置
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="id"
          url="/vehicleStockCheck/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <StockCheckView
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.viewData}
        />
        <StockCheckConfig
          visible={this.state.configVisible}
          onCancel={this.hideConfig.bind(this)}
        />
      </div>
    );
  }
}

export default StockCheckList;
